import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { adminApi, czk, fmtDate, STATUS } from "../lib/api";
import { Card, PageTitle } from "./ui";

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => {
    adminApi.get("/stats").then((r) => setS(r.data));
  }, []);
  if (!s) return <div className="h-64 animate-pulse rounded-3xl bg-white" />;
  const kpis = [["Tržby celkem", czk(s.revenue)], ["Zaplacené objednávky", s.paid_orders], ["Čeká na platbu", s.pending_orders], ["Zákazníci", s.customers], ["Produkty", s.products], ["Odběratelé novinek", s.newsletter]];
  return (
    <div data-testid="admin-dashboard">
      <PageTitle title="Přehled" sub="Jak se daří Hravé mateřince" />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-6">
        {kpis.map(([k, v], i) => (
          <motion.div key={k} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }} className={`rounded-3xl p-5 ${i === 0 ? "bg-[#7A8460] text-white" : "border bg-white"}`}>
            <p className="text-xs opacity-75">{k}</p><p className="mt-2 font-serif text-2xl font-black" data-testid={`admin-kpi-${i}`}>{v}</p>
          </motion.div>
        ))}
      </div>
      <div className="mt-6 grid gap-6 xl:grid-cols-[2fr_1fr]">
        <Card title="Tržby za 30 dní">
          <div className="h-64">
            <ResponsiveContainer>
              <AreaChart data={s.chart}>
                <defs><linearGradient id="g" x1="0" x2="0" y1="0" y2="1"><stop offset="0%" stopColor="#A3AC86" stopOpacity={0.6} /><stop offset="100%" stopColor="#A3AC86" stopOpacity={0} /></linearGradient></defs>
                <CartesianGrid stroke="#eee" vertical={false} /><XAxis dataKey="date" fontSize={11} /><YAxis fontSize={11} width={50} />
                <Tooltip formatter={(v) => czk(v)} /><Area type="monotone" dataKey="total" stroke="#7A8460" strokeWidth={2} fill="url(#g)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </Card>
        <Card title="Nejprodávanější">
          {s.top.length ? s.top.map((p) => <div key={p.name} className="flex justify-between border-b py-2 text-sm"><span>{p.name}</span><b>{p.sold} ks</b></div>) : <p className="text-sm text-[#6E7565]">Zatím žádné prodeje.</p>}
          {s.messages > 0 && <Link to="/admin/komunikace" className="mt-4 block rounded-2xl bg-[#FDF3D3] p-3 text-sm">Nové zprávy: <b>{s.messages}</b></Link>}
        </Card>
      </div>
      <Card title="Poslední objednávky" className="mt-6" action={<Link to="/admin/objednavky" className="text-sm text-[#7A8460]">Vše →</Link>}>
        <div className="divide-y">
          {s.recent.map((o) => (
            <div key={o.id} className="flex flex-wrap items-center gap-3 py-3 text-sm">
              <b className="w-28">{o.number}</b><span className="flex-1">{o.billing.name}</span><span className="text-[#6E7565]">{fmtDate(o.created_at)}</span>
              <span className={`rounded-full px-3 py-1 text-xs ${STATUS[o.status].cls}`}>{STATUS[o.status].label}</span><b className="w-24 text-right">{czk(o.total)}</b>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
